package com.anjuros.website.templates.template8.components

import androidx.compose.runtime.Composable
import com.anjuros.website.components.shared.AnjurosText
import com.anjuros.website.components.language.LocalText

import com.anjuros.website.components.language.ResKey

import com.anjuros.website.templates.template8.util.Template8Constants.FONT_FAMILY
import com.anjuros.website.templates.template8.modules.Template8MenuItem
import com.anjuros.website.templates.template8.styles.Template8Theme
import com.anjuros.website.templates.template8.styles.getColor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun Template8MenuCard(
    menuCard: Template8MenuItem
){
    Column(
        modifier = Modifier.fillMaxWidth()
            .margin(top=50.px),
        verticalArrangement = Arrangement.SpaceBetween,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {


        P(
            attrs = Modifier
                .fontFamily(FONT_FAMILY)
                .fontSize(24.px)
                .fontWeight(FontWeight.Normal)
                .color(Template8Theme.Primary.getColor())
                .toAttrs()
        ) {
            Text(LocalText(menuCard.category).uppercase())

        }

        menuCard.items.forEach { item ->
            Row(
                modifier = Modifier.fillMaxWidth()
                    .padding(leftRight = 20.px)
                    .backgroundColor(
                        if(item.index%2==0){
                            Colors.LightGrey
                        } else Colors.Transparent
                    ),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.SpaceBetween
            ) {


                Column(
                    modifier = Modifier
                        .margin(topBottom = 10.px),
                    verticalArrangement = Arrangement.Center,
                    horizontalAlignment = Alignment.Start
                ) {
                    P(
                        attrs = Modifier
                            .margin(topBottom = 0.px)
                            .fontFamily(FONT_FAMILY)
                            .fontSize(20.px)
                            .fontWeight(FontWeight.Bold)
                            .color(Colors.Black)
                            .toAttrs()
                    ) {
                        Text(LocalText(item.name))
// Add "V" if vegetarian
                        if (item.vegetarian) {
                            Span(
                                attrs = Modifier
                                    .margin(left = 8.px)
                                    .fontSize(14.px)
                                    .fontWeight(FontWeight.Bold)
                                    .color(Colors.Green) // V in green
                                    .toAttrs()
                            ) {
                                AnjurosText("V", ResKey.PLACEHOLDER_EMPTY)
                            }
                        }

                        // Add "GF" if gluten-free
                        if (item.glutenFree) {
                            Span(
                                attrs = Modifier
                                    .margin(left = 4.px)
                                    .fontSize(14.px)
                                    .fontWeight(FontWeight.Bold)
                                    .color(Colors.Orange) // orange-ish for GF
                                    .toAttrs()
                            ) {
                                AnjurosText("GF", ResKey.PLACEHOLDER_EMPTY)
                            }
                        }
                    }
                    P(
                        attrs = Modifier
                            .margin(topBottom = 0.px)
                            .fontFamily(FONT_FAMILY)
                            .fontSize(18.px)
                            .fontWeight(FontWeight.Normal)
                            .color(Template8Theme.DarkGrey.rgb)
                            .toAttrs()
                    ) {
                        Text(LocalText(item.description))

                    }
                }

                Box(
                    modifier = Modifier.fillMaxHeight(),
                    contentAlignment = Alignment.Center // center vertically
                ) {
                    P(
                        attrs = Modifier
                            .margin(topBottom = 0.px)
                            .align(Alignment.Center)
                            .fontFamily(FONT_FAMILY)
                            .fontSize(18.px)
                            .fontWeight(FontWeight.Normal)
                            .color(Template8Theme.DarkGrey.rgb)
                            .toAttrs()
                    ) {
                        AnjurosText("£${item.price}", ResKey.PLACEHOLDER_PRODUCT_PRICE)
                    }
                }
            }

        }
    }
}
